// UI Constants
export const TOAST_TIMEOUT_MS = 60000;
export const MAX_DISPLAY_ITEMS = 30;

// Validation
export const MIN_SCRIPT_LENGTH = 20;

// Colors and Styles
export const SCORE_THRESHOLDS = {
  HIGH: 80,
  MEDIUM: 60
};

export const SCORE_COLORS = {
  HIGH: 'text-green-500',
  MEDIUM: 'text-yellow-500',
  LOW: 'text-red-500'
};

export const SCORE_BG_COLORS = {
  HIGH: 'bg-green-500',
  MEDIUM: 'bg-yellow-500',
  LOW: 'bg-red-500'
};

export const PRIORITY_COLORS = {
  crítica: 'bg-red-100 border-red-300 text-red-700',
  alta: 'bg-orange-100 border-orange-300 text-orange-700',
  media: 'bg-yellow-100 border-yellow-300 text-yellow-700',
  baja: 'bg-green-100 border-green-300 text-green-700'
};
